import { DIALOG_BODY_FRAME_BACKGROUND_URL } from '../../../../../assets/deliveryDialogAssets';
import './DialogBodyFrameBackground.css';

export function DialogBodyFrameBackground() {
  return (
    <img
      className="dialog-body-frame-background"
      src={DIALOG_BODY_FRAME_BACKGROUND_URL}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
